import Resource from '@/api/resource';
import request from '@/utils/request';
import store from "@/store/index";

class Modules extends Resource {
    constructor() {
        super('modules');
    }

    list(query) {
        return request({
            url: `${this.uri}/list_modules`,
            method: 'post',
            data: query,
        })
    }

    put(id, query) {
        return request({
            url: id ? `/${this.uri}/${id}` : `/${this.uri}`,
            method: 'post',
            data: query,
            onUploadProgress: function (progressEvent) {
                store.commit('app/SET_UPLOAD_PROGRESS', parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
            }.bind(store),
        })
    }

    get(id) {
        return request({
            url: `/${this.uri}/show`,
            method: 'post',
            data: {id: id}
        })
    }
    reset(id) {
        return request({
            url: `/${this.uri}/reset`,
            method: 'post',
            data: {id: id}
        })
    }
    lookups(){
        return request({
            url: '/lookups/modules_lookups',
            method: 'get'
        })
    }
}

export {Modules as default};
